module.exports = __webpack_public_path__ + "img/newsletter.22349fa2.jpg";